export default {
  '64103b758944c1dd338a19d16fd197d0': '首',
  '29881e03534ec25fc024fc8a2e3ff9ee': '特惠价',
  '6bbfbac07bc02d84cf76b6c94808d3d5': '推荐',
  '89e166a5527c1820e7502975d901e1a7': '促销订阅方式曝光',
  '5e19d3881fe47d4f49e8f8f8260cfd7d': '选择购买方式',
  '2681afdce9e6637e63e8a98d71955b3f': '您已激活该商品，不可选择订阅',
  d872122a4d76e07589f16484bbdbe824: '您已订阅该商品',
  c94c566158c03e0115281016430a258b: '暂不支持该订阅模式',
  '389dabc52aab1c450ddadd2368a8f9d2': '折合¥',
  '5448bc0aeb322d6c73e65fb9918d8e6b': '/月',
  c53b9524f9bb83ec41c3f7494ccbe10f: '不可购买',
  '319802382328903b730e54e2cc217d5f': '次',
  '964ffeab66ae5b5439d02e3a6dd52768': '续费'
};
